import { Component } from "@angular/core";
import { UserService } from "./user.service";

@Component({
    selector: "user",
    templateUrl: "/app/user/user.template.html",
	providers: [UserService]
})
export class UserComponent{

    users: Array<IUserModel>;
    departments: Array<IDepartmentModel>;
    user = {} as IUserModel;
    message: string;

	constructor(private userService: UserService) {}

	ngOnInit() {
		this.getUsers();
	}

    getUsers(): void {
        this.userService.getUsers().subscribe((result: Array<IUserModel>) => {
			if(result)
				this.users = result;
        });
    }
}